<template>
  <div
    v-if="!showInfo"
    class="card d-flex justify-content-center align-content-center text-center poke-font-normal bg-danger"
  >
    ?
    <br />
    PoKéMoN
  </div>
  <template v-else>
    <div class="row card bg-success mx-20 mt-20">
      <div class="col-12 poke-font-gb-regular">
        <p>NOMBRE: {{ pokemon.name }}</p>
        <p>ESPECIE: {{ pokemon.species.name }}</p>
        <p>
          TIPO:
          <span
            class="badge badge-secondary badge-pill mr-5"
            v-for="t in pokemon.types"
            :key="t.slot"
            >{{ t.type.name }}</span
          >
        </p>
        <p>ALTURA: {{ pokemon.height / 10 }} m</p>
        <p>PESO: {{ pokemon.weight / 10 }} kg</p>
      </div>
    </div>
    <div></div>
  </template>
</template>

<script>
export default {
  name: 'PokemonInfo',
  props: {
    pokemon: {
      type: Object,
      required: true,
    },
    showInfo: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
}
</script>

<style scoped lang="scss"></style>
